
class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'QC';
        } else if (ENV_NAME === 'qa') {
            return 'QC QA';
        } else if (ENV_NAME === 'dev') {
            return 'QC DEV';
        } else {
            return 'QC ENV NOT FOUND';
        }
    };
}

export default EnvHelper;